var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.25 38.2171V41.3221C74.2459 48.6 71.8892 55.6816 67.5315 61.5107C63.1738 67.3398 57.0486 71.6042 50.0693 73.6677C43.0901 75.7313 35.6308 75.4835 28.8038 72.9613C21.9769 70.4391 16.1482 65.7776 12.187 59.6722C8.22577 53.5667 6.3443 46.3443 6.82316 39.0821C7.30202 31.82 10.1156 24.9072 14.8442 19.3747C19.5728 13.8422 25.9632 9.98647 33.0621 8.38254C40.1611 6.77862 47.5884 7.51244 54.2363 10.4746M74.25 14.3027L40.5 48.0865L30.375 37.9615",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBroken);
export default __webpack_public_path__ + "static/media/check-circle-broken.95c7e9994b7f6065ee38546e50b2a6c2.svg";
export { ForwardRef as ReactComponent };